// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--color-background-alt);
}

ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--color-black);
}

h1,
h2,
h3,
h4,
h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  font-family: Title;
  text-align: center;
}

h4 {
  font-size: 18px;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}

li {
  color: var(--color-black);
  font-family: AppFont;
}

p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
  text-align: center;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}

ol {
  counter-reset: item;
  padding: 0;
}

ol > li {
  display: block;
}
ol > li h3:before {
  content: counters(item, ".") ". ";
  counter-increment: item;
  margin-right: 6px;
}
ol > li p {
  display: block;
  margin: 0;
}
ol > li ol > li {
  margin: 8px 0;
  display: flex;
  flex-direction: row;
}

ol > li:before {
  content: counters(item, ".") " ";
  counter-increment: item;
  margin: 0 8px 0 0;
}

ion-content > ol {
  padding: 0;
}

ion-content > ol > li:before {
  content: none;
}

ul {
  list-style-type: disc;
  padding-left: 30px;
}

ion-content > ol > li > div {
  padding-left: 30px;
}

p.ion-padding-start {
  padding-left: 30px;
}

.legal__container {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 50rem;
}

.legal__title {
  font-family: AppFontBold;
  font-size: 40px;
  margin-top: 30px;
}
.legal__title.second {
  margin-top: 140px;
}

.legal__subtitle {
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  line-height: 1.2;
  text-transform: uppercase;
  margin-bottom: 30px;
}

h3 {
  font-size: 30px;
  margin-bottom: 30px;
}

p:has(strong) {
  margin-top: 20px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tos/tos.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,yCAAA;AADD;;AAGA;EACC,gBAAA;EACA,2CAAA;AAAD;;AAEA;;;;;EAKC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACC,kBAAA;AACF;;AACA;EACC,eAAA;AAED;AClBE;EDeF;IAGE,eAAA;EAIA;AACF;;AADA;EACC,yBAAA;EACA,oBAAA;AAID;;AADA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACC,kBAAA;AAIF;ACnCE;ED2BF;IAOE,eAAA;EAKA;AACF;;AAFA;EACC,mBAAA;EACA,UAAA;AAKD;;AAFA;EACC,cAAA;AAKD;AAJC;EACC,iCAAA;EACA,uBAAA;EACA,iBAAA;AAMF;AAHC;EACC,cAAA;EACA,SAAA;AAKF;AAFC;EACC,aAAA;EACA,aAAA;EACA,mBAAA;AAIF;;AAAA;EACC,gCAAA;EACA,uBAAA;EACA,iBAAA;AAGD;;AAAA;EACC,UAAA;AAGD;;AAAA;EACC,aAAA;AAGD;;AAAA;EACC,qBAAA;EACA,kBAAA;AAGD;;AAAA;EACC,kBAAA;AAGD;;AAAA;EACC,kBAAA;AAGD;;AAAA;EACC,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAGD;;AAAA;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;AAGF;AADE;EACE,iBAAA;AAGJ;;AACA;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;AAEF","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\t--background: var(--color-background-alt);\n}\nion-header {\n\tbox-shadow: none;\n\tborder-bottom: 1px solid var(--color-black);\n}\nh1,\nh2,\nh3,\nh4,\nh5 {\n\tfont-size: 20px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tfont-family: Title;\n  text-align: center;\n}\nh4 {\n\tfont-size: 18px;\n\t@include mobile {\n\t\tfont-size: 15px;\n\t}\n}\n\nli {\n\tcolor: var(--color-black);\n\tfont-family: AppFont;\n}\n\np {\n\tfont-size: 16px;\n\tline-height: 120%;\n\tvertical-align: middle;\n  text-align: center;\n\n\t@include mobile {\n\t\tfont-size: 14px;\n\t}\n}\n\nol {\n\tcounter-reset: item;\n\tpadding: 0;\n}\n\nol > li {\n\tdisplay: block;\n\th3:before {\n\t\tcontent: counters(item, '.') '. ';\n\t\tcounter-increment: item;\n\t\tmargin-right: 6px;\n\t}\n\n\tp {\n\t\tdisplay: block;\n\t\tmargin: 0;\n\t}\n\n\tol > li {\n\t\tmargin: 8px 0;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t}\n}\n\nol > li:before {\n\tcontent: counters(item, '.') ' ';\n\tcounter-increment: item;\n\tmargin: 0 8px 0 0;\n}\n\nion-content > ol {\n\tpadding: 0;\n}\n\nion-content > ol > li:before {\n\tcontent: none;\n}\n\nul {\n\tlist-style-type: disc;\n\tpadding-left: 30px;\n}\n\nion-content > ol > li > div {\n\tpadding-left: 30px;\n}\n\np.ion-padding-start {\n\tpadding-left: 30px;\n}\n\n.legal__container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin: 0 auto;\n\tmax-width: 50rem;\n}\n\n.legal__title {\n  font-family: AppFontBold;\n  font-size: 40px;\n  margin-top: 30px;\n\n  &.second {\n    margin-top: 140px;\n  }\n\n}\n.legal__subtitle {\n  font-size: 0.75rem;\n  letter-spacing: 0.05em;\n  line-height: 1.2;\n  text-transform: uppercase;\n  margin-bottom: 30px;\n}\n\nh3 {\n  font-size: 30px;\n  margin-bottom: 30px;\n}\n\np:has(strong) {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
